{#if mainObj.toneJsObj.fullHash !== ""}

	<h2>
		<a target="_blank" href="https://tonejs.github.io/" rel="noopener">
			♯Tone.Js
		</a>
	</h2>

	<div class="fullhash-wrapper--tonejs">
		<code id="code" style="white-space: nowrap;">
			{#each mainObj.transactionFullHashToUpper.split("") as toneJsEachWord, index}
				<b id={index} class="tonejs-eachword">{toneJsEachWord}</b>
			{/each} 
		</code>
	</div>

{:else}

	<button on:click={makeFullHashForToneJs(mainObj.transactionFullHashToUpper)}> play Tone.js 🎹 </button>

{/if}

<style lang="scss">
	.fullhash-wrapper--tonejs {
		margin: 1rem -1.1em 0;
		padding: .5rem;
		background-color: #fff;
		overflow-x: scroll;
		pointer-events: none;
	}
</style>


<script>
	import { afterUpdate } from "svelte";	

	const d = document;
	// 強調するためのnth-index用
	const chordIndexesForEmphasis = [];
	let schedule = 0;

	// 渡されてきたやつら
	export let mainObj;
	
	// DOM更新後
	afterUpdate(()=>{
		
		// <code>内 ビュー変更用
		(()=>{
			chordIndexesForEmphasis.forEach(i=>{
			const r = Math.floor(Math.random() * 255);
			const g = Math.floor(Math.random() * 255);
			const b = Math.floor(Math.random() * 255);
			const color = `rgb(${r},${g},${b})`;

			d.getElementById(i).style.color = color;
			d.getElementById(i).style.fontSize = "1.25em";
			d.getElementById(i+1).style.color = color;
			d.getElementById(i+1).style.fontSize = "1.25em";

			d.getElementById(i).insertAdjacentHTML("beforebegin",'<i style="background-color: #fff;">　 </i>');
			});
		})();

		// boxの横幅のサイズ取得して それを時間で割った分 自動スクロールさせる
		(()=>{
			const codeBox         = d.getElementById("code");
			const fullHashWrapper = d.querySelector(".fullhash-wrapper--tonejs");
			for(let i=0;i<Math.round(schedule);i++){
				setTimeout(function(){
					fullHashWrapper.scrollBy({
							left: codeBox.getBoundingClientRect().width / Math.round(schedule),
							behavior: 'smooth'
						});
				}, i*1000 );
			}
		})();		

	});

	// --------------
	// Tone.js発火
	// --------------
	// Tone.js最適 文字列切り出し
	function makeFullHashForToneJs(fullHash){
		
		const chordSet = new Set("ABCDEFG".split(""));
		const numSet   = new Set("1234567".split(""));
		
		// 一旦"音"と関係ないものに分離処理
		let fixedFullHash = "";
		for(let i=0;i<fullHash.length;i++){

			// 文字にコードが含まれているか？
			if( chordSet.has(fullHash[i]) && numSet.has(fullHash[i+1]) ){
					// 次の文字が番号1~7の番号だった場合tonejs鳴らせる
					fixedFullHash += ","+fullHash[i];
					// また表示強調用のindex集約配列へpush
					chordIndexesForEmphasis.push(i);
			} else {
				fixedFullHash += fullHash[i];
			}
		}

		mainObj.toneJsObj.fullHash = fixedFullHash;
		playToneJs(mainObj.toneJsObj.fullHash);
	}
	function playToneJs(fullHashForToneJs){
		
		const synth = new Tone.AMSynth().toDestination();
		const now = Tone.now();

		const fullHashArr = fullHashForToneJs.split(",");
		fullHashArr.forEach((block,index)=>{

			// 38がmaxくらいだが一応バッファはあるっぽい
			// if(block.length > 20){
			// 	console.log(block.length);
			// }

			// トーンが含まれるブロックごとに処理掛けてく
			const tone = `${block[0]}${block[1]}`;
			const blockLeftNumArr = [];
			for(let i=0;i<block.length;i++){
				if( i!==0 && i!==1 && isFinite(block[i]) ){
					blockLeftNumArr.push(block[i]); // 数値を集める(自動型変換)
				}
			}

			if( blockLeftNumArr.length > 3 ){
				blockLeftNumArr.splice(3,blockLeftNumArr.length-3); // 3個以上数値ある場合前3つのみ保持
			} else if( blockLeftNumArr.length === 0 ){
				blockLeftNumArr.push(1); // 逆に何もない時は1を入れる
			}

			// 最初のブロックの要素数でschedule算出			
			const scheduleBase = fullHashArr[0].length;
			schedule           = now + index/scheduleBase + block.length/(scheduleBase*35);

			synth.triggerAttackRelease( tone, blockLeftNumArr.join(":") ,  schedule );
			if( index === fullHashArr.length - 1 ){
				// ここで実際の秒数が分かる 
				console.log( "約" + schedule + "秒音楽長");
			}
		});
	}	
</script>

